import { render, staticRenderFns } from "./dealerctradeMt.vue?vue&type=template&id=079b9e12&scoped=true"
import script from "./dealerctradeMt.vue?vue&type=script&lang=js"
export * from "./dealerctradeMt.vue?vue&type=script&lang=js"
import style0 from "./dealerctradeMt.vue?vue&type=style&index=0&id=079b9e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b9e12",
  null
  
)

export default component.exports